module.exports = __webpack_public_path__ + "img/pinganshun-xiaochengxu.83bc70d0.jpg";